import { useContext } from 'react'
import ActiveItemDivider from './ActiveItemDivider';
import { CraftIdentityContext } from 'pages/CraftIdentity';
import Cookies from 'js-cookie';
import useActiveItem from 'hooks/useActiveItem';

const ActiveItemIdentityCraftSelect = ({ item }) => {
  const {activeItem} = useActiveItem();
  const { selectItemHandler, playSound } = useContext(CraftIdentityContext);

  const isBuyFromMarket = Cookies.get('isBuyFromMarket');


  const selectHandler = (item) => {
    playSound('craftSelectItem');
    selectItemHandler(item);
  }

  return <>
    {
      activeItem.owned_by_self &&
      <button className='card-details__combine-action card-details__combine-action--select' disabled={isBuyFromMarket} onClick={() => selectHandler(item)}>Select</button>
    }
    <ActiveItemDivider />
  </>
}

export default ActiveItemIdentityCraftSelect;
